import {AfterViewInit, Component, ElementRef, ViewChild} from '@angular/core';

@Component({
  selector: 'app-startseite',
  templateUrl: './startseite.component.html',
  styleUrl: './startseite.component.css'
})
export class StartseiteComponent implements AfterViewInit {

  @ViewChild('videoElement', {static: true}) videoElement!: ElementRef

  protected readonly document = document;

  ngAfterViewInit(): void {
    const media = this.videoElement.nativeElement
    media.muted = true
    media.play()
  }
}
